import React from 'react';
import {PLAN_PANEL_WIDTH, SCHEDULE_FIELD_HEIGHT} from './../../constants/cssConstants';
import QuarterTitles from "./QuarterTitles";
import Quarters from "./Quarters";

class PlanPanel extends React.Component {
    render() {
        return (
            <div style={{ height: SCHEDULE_FIELD_HEIGHT, width: PLAN_PANEL_WIDTH }}>
                <QuarterTitles />
                <Quarters
                    plan={this.props.plan}
                    isLoading={this.props.isLoading}
                    addCourseToPlan={this.props.addCourseToPlan}
                    moveCourse={this.props.moveCourse}
                    removeCourseFromPlan={this.props.removeCourseFromPlan}
                    getUnits={this.props.getUnits}
                    setIsDragging={this.props.setIsDragging}
                />
            </div>
        );
    }
}

export default PlanPanel;